import { Dayjs } from "dayjs";
import { FlightIcon } from "src/assets/Icons";
import i18n from "src/i18n";
import { formatDate, formatNumber } from "src/utility";
import type { DataMap } from "../../../OrderCard/constants";
import type { OrderStatusKey } from "../../../../constants";

type FlightTransaction = {
  referenceNumber: string;
  pnr: string | null;
  airlineName: string;
  origin: string;
  destination: string;
  departureDate: string;
  passengerCount: number;
  bookingStatus: OrderStatusKey;
  ticketStatus: OrderStatusKey;
  totalAmount: number;
  pointsUsed: number;
  orderDate: string;
};

type FlightTransactionsRequest = {
  dateFrom?: string;
  dateTo?: string;
  clientId?: string;
};

const FLIGHT_CARD_ICON = (
  <div className="rounded-xl bg-background-minimal p-2" aria-hidden="true">
    <FlightIcon className="text-font-active" aria-hidden="true" />
  </div>
);

const FLIGHT_CARD_DATA_MAP = {
  referenceNumber: {
    get label() {
      return i18n.t("UserHistory.ordersList.referenceNumber");
    },
  },
  pnr: {
    get label() {
      return i18n.t("UserHistory.ordersList.bookingReferencePnr");
    },
    value: (val: string | null) => val ?? "-",
  },
  passengerCount: {
    get label() {
      return i18n.t("UserHistory.ordersList.numberOfPassengers");
    },
  },
  orderDate: {
    get label() {
      return i18n.t("UserHistory.ordersList.orderDate");
    },
    value: (val: string | Dayjs) => formatDate(val, "YYYY-MM-DD, hh:mm A"),
  },
  totalAmount: {
    get label() {
      return i18n.t("UserHistory.ordersList.totalAmount");
    },
    value: (value: number) => formatNumber(value),
  },
  pointsUsed: {
    get label() {
      return i18n.t("UserHistory.ordersList.pointsUsed");
    },
    value: (value: number) => (
      <span className="text-font-active">{i18n.t("UserHistory.ordersList.pointsValue", { value: formatNumber(value) })}</span>
    ),
  },
} satisfies DataMap;

export type { FlightTransaction, FlightTransactionsRequest };
export { FLIGHT_CARD_ICON, FLIGHT_CARD_DATA_MAP };
